import { Illustration } from "../Illustration.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/illustration/variants/FemaleDoctorIllustration.tsx
const FemaleDoctorIllustration = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(Illustration, {
		...props,
		svgFile: "female-doctor.svg",
		alt: t("illustration.imageAlt.femaleDoctor")
	});
};

//#endregion
export { FemaleDoctorIllustration };